import { useCallback } from 'react'
import { useLazyQuery } from '@apollo/client'

import { useCache } from '~/shared/hooks'
import { QUERY_POST } from '~/modules/post/queries'

/**
 *
 */
export default function usePost() {
  const { getData, setData } = useCache()

  const [queryPost, { data, error, loading, refetch }] =
    useLazyQuery(QUERY_POST)

  const getPost = useCallback(
    (postId: string) => {
      const result = getData({
        query: QUERY_POST,
        variables: { id: postId, refreshMedia: false },
      })

      return result ? result.engagePost : null
    },
    [getData],
  )

  const setPost = useCallback(
    (postId: string, post: any) => {
      setData({
        query: QUERY_POST,
        variables: { id: postId, refreshMedia: false },
        data: { engagePost: post },
      })
    },
    [setData],
  )

  return {
    post: data ? data.engagePost : null,
    getPost,
    setPost,
    queryPost,
    queryPostStatus: { loading, error, refetch },
  }
}
